import React, { useState } from 'react';
import { Box, Typography, Skeleton, Modal, IconButton } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { ZoomIn as ZoomInIcon, Close as CloseIcon } from '@mui/icons-material';
import useManualPalette from '../../hooks/useManualPalette';

const ManualScreenshot = ({ src, alt, caption }) => {
  const MP = useManualPalette();
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);
  const [lightboxOpen, setLightboxOpen] = useState(false);

  if (error) return null;

  return (
    <>
      <Box sx={{ my: 3, textAlign: 'center', '&:hover .zoom-hint': { opacity: 1 } }}>
        {!loaded && (
          <Skeleton variant="rectangular" width="80%" height={220}
            sx={{ mx: 'auto', borderRadius: 2, bgcolor: alpha(MP.blue, 0.15) }} />
        )}
        <Box
          sx={{
            display: loaded ? 'inline-block' : 'none',
            position: 'relative',
            cursor: 'zoom-in',
            borderRadius: 2,
            overflow: 'hidden',
            boxShadow: `0 4px 20px ${alpha(MP.deepBlue, 0.35)}`,
            border: `2px solid ${alpha(MP.yellow, 0.25)}`,
          }}
          onClick={() => setLightboxOpen(true)}
        >
          <img
            src={src}
            alt={alt || caption}
            onLoad={() => setLoaded(true)}
            onError={() => { setError(true); setLoaded(true); }}
            style={{ display: 'block', maxWidth: '100%', height: 'auto', maxHeight: 480 }}
          />
          <Box className="zoom-hint" sx={{
            position: 'absolute', top: 8, right: 8,
            bgcolor: alpha(MP.deepBlue, 0.75),
            borderRadius: 1, p: 0.5, opacity: 0,
            transition: 'opacity 0.2s', color: MP.yellow,
            display: 'flex', alignItems: 'center',
          }}>
            <ZoomInIcon sx={{ fontSize: 18 }} />
          </Box>
        </Box>
        {caption && (
          <Typography variant="caption" display="block"
            sx={{ mt: 1, color: alpha(MP.deepBlue, 0.6), fontStyle: 'italic' }}>
            {caption}
          </Typography>
        )}
      </Box>

      <Modal open={lightboxOpen} onClose={() => setLightboxOpen(false)}>
        <Box
          sx={{
            position: 'fixed', inset: 0,
            bgcolor: alpha(MP.black, 0.95),
            display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2,
          }}
          onClick={() => setLightboxOpen(false)}
        >
          <IconButton sx={{ position: 'absolute', top: 16, right: 16, color: MP.yellow }}
            onClick={() => setLightboxOpen(false)}>
            <CloseIcon />
          </IconButton>
          <img src={src} alt={alt || caption}
            style={{ maxWidth: '95vw', maxHeight: '95vh', objectFit: 'contain', borderRadius: 8,
              border: `2px solid ${alpha(MP.yellow, 0.3)}` }} />
        </Box>
      </Modal>
    </>
  );
};

export default ManualScreenshot;
